import axios from "axios";
import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { fade, lighten, makeStyles, useTheme } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
// import TablePagination from '@material-ui/core/TablePagination';
import TablePagination from "@mui/material/TablePagination";

import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Checkbox from "@material-ui/core/Checkbox";
import IconButton from "@material-ui/core/IconButton";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";

import Tooltip from "@material-ui/core/Tooltip";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
//import AccountCircle from '@material-ui/icons/AccountCircle';
import IconSearchRounded from "@material-ui/icons/SearchRounded";
import SearchIcon from "@material-ui/icons/Search";
import InputBase from "@material-ui/core/InputBase";
import DatawarehouseDealerDetail from "./DatawarehouseDealerDetail";
import { createLiteralTypeNode } from "typescript";
import { Box } from "@mui/material";

function TablePaginationActions(props: any) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event: any) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event: any) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event: any) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event: any) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
}));

//function descendingComparator(a, b, orderBy: any) {
function descendingComparator(a: any, b: any, orderBy: any) {
  //alert(a[orderBy]);
  //console.log("orderBy:" + orderBy);
  var x = a[orderBy];
  var y = b[orderBy];
  //console.log("orderBy: " + orderBy );

  if (orderBy.toLowerCase() == "dealername") {
    //console.log("123orderBy:" );
    x = x.toLowerCase();
    y = y.toLowerCase();
    //console.log("456orderBy:" );
    //console.log("123orderBy:" + orderBy + " : " + x );
  }
  if (a[orderBy] == null) {
    if (orderBy == "dateLastUsed") {
      x = "01/01/2020";
    }
  }
  if (b[orderBy] == null) {
    if (orderBy == "dateLastUsed") {
      y = "01/01/2020";
    }
  }

  // if (b[orderBy] < a[orderBy]) {
  //     return -1;
  // }
  // if (b[orderBy] > a[orderBy]) {
  //     return 1;
  // }
  if (y < x) {
    return -1;
  }
  if (y > x) {
    return 1;
  }
  return 0;
}

function getComparator(order: any, orderBy: any) {
  return order === "desc"
    ? (a: any, b: any) => descendingComparator(a, b, orderBy)
    : (a: any, b: any) => -descendingComparator(a, b, orderBy);
}

function stableSort(array: any, comparator: any) {
  const stabilizedThis = array.map((el: any, index: any) => [el, index]);
  stabilizedThis.sort((a: any, b: any) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el: any) => el[0]);
}

const headCells = [
  { id: "dealerId", numeric: true, disablePadding: false, label: "DealerId" },
  {
    id: "dmsDealerId",
    numeric: true,
    disablePadding: false,
    label: "DmsId-Location",
  },
  { id: "dealerName", numeric: false, disablePadding: false, label: "Name" },
  { id: "address", numeric: false, disablePadding: false, label: "Address" },
  { id: "dmsName", numeric: false, disablePadding: false, label: "Type" },
  { id: "phone", numeric: false, disablePadding: false, label: "Phone" },
  { id: "email", numeric: false, disablePadding: false, label: "Email" },
  //   { id: "Notes", numeric: false, disablePadding: false, label: "Version#" },
  {
    id: "lastUpdated",
    numeric: false,
    disablePadding: false,
    label: "Last Update",
  },
];

function EnhancedTableHead(props: any) {
  const {
    classes,
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property: any) => (event: any) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow style={{ backgroundColor: "#F4F6F7", fontWeight: "bold" }}>
        {/* <TableCell padding="checkbox">
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ 'aria-label': 'select all desserts' }}
          />
        </TableCell> */}
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "default"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              <div style={{ whiteSpace: "nowrap" }}>{headCell.label}</div>
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: "1 1 100%",
  },
}));

const EnhancedTableToolbar = (props: any) => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  return (
    <div></div>
    // <Toolbar
    //   className={clsx(classes.root, {
    //     [classes.highlight]: numSelected > 0,
    //   })}
    // >
    //   {numSelected > 0 ? (
    //     <Typography className={classes.title} color="inherit" variant="subtitle1" component="div">
    //       {numSelected} selected
    //     </Typography>
    //   ) : (
    //     <Typography className={classes.title} variant="h6" id="tableTitle" component="div">
    //       Nutrition
    //     </Typography>
    //   )}

    //   {numSelected > 0 ? (
    //     <Tooltip title="Delete">
    //       <IconButton aria-label="delete">
    //         {/* <DeleteIcon /> */}
    //       </IconButton>
    //     </Tooltip>
    //   ) : (
    //     <Tooltip title="Filter list">
    //       <IconButton aria-label="filter list">
    //         {/* <FilterListIcon /> */}
    //       </IconButton>
    //     </Tooltip>
    //   )}
    // </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  inActiveDealer: {
    color: "red",
    textDecoration: "line-through",
  },
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
    "& .MuiTableCell-root": {
      fontSize: "0.8rem",
      paddingLeft: "10px",
      paddingRight: "10px",
    },
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(1),
      width: "auto",
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
  },
  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    color: "white",
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    fontWeight: "bolder",
    [theme.breakpoints.up("sm")]: {
      width: "12ch",
      "&:focus": {
        width: "20ch",
      },
    },
  },
}));

export default function EverestDealers({ search }: { search: string }) {
  //const EverestDealers = (props: any) => {
  // alert('EnhancedTable');

  // export default function EnhancedTable(props) {
  //const { dealerId } = props.id;
  //  console.error("eeeeeee");
  //  console.error(props);
  //  alert(props.id);
  //  console.error(ppppppp);
  const classes = useStyles();
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("dealerName");
  const [selected, setSelected] = React.useState([]);
  const [dense, setDense] = React.useState(true);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(20);
  const [data, SetData] = useState([] as any);
  const [searchdata, SetSearchdata] = useState("");
  const [loading, setLoading] = useState("Please wait.. gathering data");
  const [isPaneOpen, SetIsPaneOpen] = React.useState(false);
  const [childMessages, SetChildMessages] = useState([] as any);

  // const [dealerName, SetDealerName] = useState([]);
  // const [editDealerID, SetEditDealerID] = useState(0);
  // const [currentLocationRow, SetCurrentLocationRow] = useState([]);

  let rowEventHandled = 0;

  function GetData() {
    if (data == null || data == undefined || data.length == 0) return [];
    if (data.data == null || data.data == undefined || data.data.length == 0)
      return [];
    // alert(data.length);
    // alert('getdata');
    return data.data;
    // return data.filter(filterRow);
  }
  function TotalRows() {
    if (data == null || data == undefined || data.length == 0) return [];
    return data.count;
  }

  function filterRow(element: any, index: any, array: any) {
    if (data.length > 0) {
      var obj1 = data[0];
      var keys = Object.keys(obj1);
      let i = 0;
      for (i = 0; i < keys.length; i++) {
        let cellValue = String(element[keys[i]]);
        if (cellValue.toLowerCase().includes(searchdata.toLowerCase())) {
          return true;
        }
      }
    }
    return false;

    // if (myName === '') { return true };
    // let name: string = element['name'];
    // let address: string = element['address'];
    // if (name.toLowerCase().includes(myName.toLowerCase())) { return true; }
    // if (address.toLowerCase().includes(myName.toLowerCase())) { return true; }
    // return false;
  }

  function closeModal() {
    SetIsPaneOpen(false);
  }

  useEffect(() => {
    GetDataFromEverest();
  }, [page, rowsPerPage, search, orderBy, order]);

  function GetDataFromEverest() {
    let obj: any = new Object();
    obj.orderBy = orderBy;
    obj.order = order;
    obj.page = page;
    obj.rowsPerPage = rowsPerPage;
    obj.search = search;
    let jsonString = JSON.stringify(obj);
    console.log("jsonString: " + jsonString);
    // alert(jsonString);
    var tkn = "Y1N5c3RlbXM6U0hyaXNqMENuaGxw";
    const body = {
      query: "EverestDealersKG",
      queryBody: obj,
    };
    axios
      .post("https://csidealerProd.azurewebsites.net/api/Query", body, {
        headers: {
          Authorization: `Bearer ${tkn}`,
        },
      })
      .then((response) => {
        console.log(response.data);
        SetData(response.data);
        setLoading("");
        SetIsPaneOpen(true);
      })
      .catch((error) => {
        console.error(error);
      });
    // const requestOptions = {
    //     method: 'POST',
    //     headers: { 'Content-Type': 'application/json' },
    //     body: jsonString
    // };
    // //alert('GetDataFromEverest');
    // //let url = "http://localhost:7071/api/GetDWDealersV2";
    // //let url = window.DataService.url + 'api/GetDWDealers?code=Orn2wOUhCTai5VcfFsRFmjH/uhmwyMflvONBsxzpzXJIFtzztJVzdg==';
    // let url = 'https://azurefunctionkg.azurewebsites.net/api/GetDWDealersV2?code=8e7e0AOUnSE/s1UxPxyOCZHN0nrOh81eZAOdvEBvsCf9bj1efIldMQ==';
    // fetch(url, requestOptions)
    //     .then(response => response.json())
    //     .then(data =>
    //     (
    //         SetData(data),
    //         setLoading(''),
    //         SetIsPaneOpen(true)

    //     )

    //     ).catch(error => alert('Error: ' + error));
  }

  const handleRequestSort = (event: any, property: any) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event: any) => {
    // if (event.target.checked) {
    //     alert('handleSelectAllClick');
    //     const newSelecteds = data.map((n) => n.name);
    //     setSelected(newSelecteds);
    //     return;
    // }
    // setSelected([]);
  };

  const handleRowClick = (event: any, name: any) => {
    // const selectedIndex = selected.indexOf(name);
    // let newSelected = [];
    // if (selectedIndex === -1) {
    //     newSelected = newSelected.concat(selected, name);
    // } else if (selectedIndex === 0) {
    //     newSelected = newSelected.concat(selected.slice(1));
    // } else if (selectedIndex === selected.length - 1) {
    //     newSelected = newSelected.concat(selected.slice(0, -1));
    // } else if (selectedIndex > 0) {
    //     newSelected = newSelected.concat(
    //         selected.slice(0, selectedIndex),
    //         selected.slice(selectedIndex + 1),
    //     );
    // }
    // setSelected(newSelected);
  };

  const handleChangePage = (event: any, newPage: any) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event: any) => {
    setDense(event.target.checked);
  };

  const handleDealerRowClick = (currentRow: any) => {
    let _datawarehouseDealerDetail = (
      <DatawarehouseDealerDetail
        key={new Date().getTime()}
        DealerId={currentRow.dealerId}
        dmsDealerId={currentRow.dmsDealerId}
        currentRow={currentRow}
      />
    );
    SetChildMessages(_datawarehouseDealerDetail);
  };

  function GetDmsDealerId(currentRow: any) {
    var dmsDealerId = currentRow.dmsDealerId;
    if (currentRow.dmsLocationId > 0)
      dmsDealerId += "-" + currentRow.dmsLocationId;
    if (currentRow.dealerNumber != null && currentRow.dealerNumber.length > 0) {
      dmsDealerId += " (" + currentRow.dealerNumber + ") ";
    }
    if (currentRow.dmsLocationId == 0) {
      dmsDealerId = "\u2713 " + dmsDealerId;
    } else if (
      currentRow.dealerId == currentRow.companyDealerId &&
      currentRow.dmsDealerId == currentRow.dmsLocationId
    ) {
      dmsDealerId = "\u2713\u2713 " + dmsDealerId;
    } else if (currentRow.dealerId == currentRow.companyDealerId) {
      dmsDealerId = "\u2713 " + dmsDealerId;
    }

    // dealerNumber +='<> ' + dealerNumber+ '</><>&#x2713;</>';

    return dmsDealerId;
  }

  function TolocalTime(utcDate: any) {
    if (utcDate == null) return "";
    const localDateTime = new Date(utcDate).toLocaleString();
    return localDateTime;
  }

  function GetDmsRoot(row: any): any {
    try {
      const jsonString = row?.dmsInfo;
      if (jsonString == null || String(jsonString).trim().length === 0)
        return null;
      const parsed = JSON.parse(jsonString);
      return parsed?.DmsInfo ?? parsed;
    } catch (e) {
      return null;
    }
  }

  function GetCompanyInfoName(row: any): string {
    try {
      const dmsRoot = GetDmsRoot(row);
      if (dmsRoot == null) return "";
      let companyInfo = dmsRoot?.CompanyInfo;
      if (companyInfo == null) return "";

      if (typeof companyInfo === "string") {
        if (companyInfo.trim().length === 0) return "";
        companyInfo = JSON.parse(companyInfo);
      }

      const companyName = companyInfo?.Name;
      if (companyName == null) return "";
      return String(companyName).trim();
    } catch (e) {
      return "";
    }
  }

  function IsPrimaryLocation(row: any): boolean {
    const dmsRoot = GetDmsRoot(row);
    if (dmsRoot == null) return false;
    const isPrimary = dmsRoot.IsPrimary;
    return isPrimary === 1 || isPrimary === "1" || isPrimary === true;
  }

  // const isSelected = (name :any) => selected.indexOf(name) !== -1;

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);

  return (
    <div style={{ margin: "10px 15px", fontWeight: "bold" }}>
      {/* <div style={{ position: "relative", border: "0px solid red" }} className={classes.root}> */}

      {/* <SlidingPane
                className='some-custom-class'
                overlayClassName='some-custom-overlay-class'
                isOpen={isPaneOpen}
                title={props.dealer}
                subtitle="Survey's In last 30 days"
                onRequestClose={closeModal}> */}

      <div style={loading == "" ? { display: "none" } : {}}>
        <h1>{loading}</h1>
      </div>
      {/* {searchdata} */}
      {/* <Paper xclassName={classes.paper} xstyle={{ width:1175, marginTop:10  }}></Paper> */}
      <Paper style={{ display: "table" }}>
        {/* <div style={{ position: "fixed", top: "8px", right: "10px" }}>
                    <table>
                        <tr>
                            <td>
                                <div style={{ position: "fixed", right: "15px", top: "15px" }} className={classes.search}>
                                    <div className={classes.searchIcon}>
                                        <SearchIcon />
                                    </div>
                                    <InputBase
                                        placeholder="Search…"
                                        classes={{
                                            root: classes.inputRoot,
                                            input: classes.inputInput,
                                        }}
                                        inputProps={{ 'aria-label': 'search' }}
                                        onChange={(e) => SetSearchdata(e.target.value)}
                                    />
                                </div>

                            </td>
                            <td>


                            </td>
                        </tr>
                    </table>
                </div> */}

        <EnhancedTableToolbar numSelected={selected.length} />
        <TableContainer>
          <Table
            className={"myTable2 " + classes.table}
            aria-labelledby="tableTitle"
            size={dense ? "small" : "medium"}
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              classes={classes}
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={0}
              // rowCount={GetData()?0:GetData().length}
              // rowCount={GetData()?0:GetData().length}
            />
            <TableBody>
              {
                //    stableSort(rows, getComparator(order, orderBy))
                // stableSort(GetData(), getComparator(order, orderBy))

                // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                //data

                GetData().map((row: any, index: any) => {
                  console.warn("ktest");
                  // const isItemSelected = isSelected(row.dealerId);
                  const labelId = `enhanced-table-checkbox-${index}`;
                  let name = row.dealerName;
                  let inactive = 0;
                  if (!row.isActive) {
                    name = name + " [INACTIVE] ";
                    inactive = 1;
                  }
                  // if (row.isDealerLocation == "False") { name = name + " [ISDEALERLOCATION=0]"; inactive = 1 };
                  let xclass = "";
                  if (inactive == 1) xclass = classes.inActiveDealer;
                  let notes = row.Notes;
                  //   let xIndex = notes.lastIndexOf(";");
                  //   if (xIndex > -1) notes = notes.substring(xIndex + 1);
                  //if(notes.lastIndexOf()
                  // xclass="";

                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      onClick={(event) => handleDealerRowClick(row)}
                      // aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row.name}
                      // selected={isItemSelected}
                    >
                      <TableCell align="right">{row.dealerId}</TableCell>
                      {/* <TableCell align="right">{row.dmsDealerId}</TableCell> */}
                      <TableCell align="right">
                        {IsPrimaryLocation(row) && (
                          <span
                            style={{
                              color: "#f5b301",
                              marginRight: "4px",
                            }}
                            title="Primary location"
                          >
                            {"★"}
                          </span>
                        )}
                        {GetDmsDealerId(row)}
                      </TableCell>

                      <TableCell className={xclass}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            flexWrap: "wrap",
                          }}
                        >
                          <span>{name}</span>
                          {(() => {
                            const companyName = GetCompanyInfoName(row);
                            if (companyName.length === 0) return null;
                            if (
                              row?.dealerName != null &&
                              String(row.dealerName).trim().toLowerCase() ===
                                companyName.toLowerCase()
                            ) {
                              return null;
                            }
                            return (
                              <span
                                style={{
                                  display: "inline-block",
                                  padding: "1px 6px",
                                  border: "1px solid #d0d7de",
                                  borderRadius: "10px",
                                  backgroundColor: "#f6f8fa",
                                  color: "#24292f",
                                  fontSize: "0.65rem",
                                  fontWeight: "normal",
                                  lineHeight: 1.3,
                                  whiteSpace: "nowrap",
                                }}
                                title={companyName}
                              >
                                {companyName}
                              </span>
                            );
                          })()}
                        </div>
                      </TableCell>
                      <TableCell>
                        {[
                          row.address,
                          row.city,
                          row.stateOrProvince,
                          row.zipPostal,
                        ]
                          .filter(
                            (v) => v != null && String(v).trim().length > 0,
                          )
                          .join(", ")}
                      </TableCell>
                      <TableCell>{row.dmsName}</TableCell>
                      <TableCell>{row.phone}</TableCell>
                      <TableCell>{row.email}</TableCell>
                      {/* <TableCell>{notes}</TableCell> */}
                      <TableCell>{TolocalTime(row.lastUpdated)}</TableCell>
                    </TableRow>
                  );
                })
              }
              {emptyRows > 0 && (
                <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {/* <TablePagination
                    rowsPerPageOptions={[10, 15, 20, 25, 30]}
                    component="div"
                    count={GetData().length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                /> */}
        {/* <TablePagination
                  rowsPerPageOptions={[5, 10, 20, 25, 50, 100]}
                  component="div"
                  count={GetData().length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />                 */}

        <table>
          <tr>
            <td style={{ paddingLeft: "10px", fontWeight: "normal" }}>
              Everest&nbsp;Dealers
            </td>
            <td style={{ width: "100%" }}>
              <TablePagination
                rowsPerPageOptions={[5, 10, 15, 20, 25, 100]}
                component="div"
                count={TotalRows()}
                //count={5776}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </td>
          </tr>
        </table>
      </Paper>
      <div>{childMessages}</div>
      {/* </SlidingPane> */}
    </div>
  );
}
// export default EverestDealers
